import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allDate,
  allMonth,
  formLabelsTheme,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputLabel,
} from "@material-ui/core";
import SelectMUI from "@material-ui/core/Select";
import { Autocomplete } from "@material-ui/lab";
import { addParty } from "./partySlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const PartyCreate = ({
  isOpen,
  handleShow,
  formValues,
  setFormValues,
  setShow,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataClientRelated = useSelector(selectParameter);
  const dataCarier = useSelector(selectParameter2);

  const [clientRelated, setClientRelated] = useState([]);
  const [carier, setCarier] = useState([]);

  const handleClose = () => {
    setFormValues({
      party_code: {
        value: "",
        error: false,
        required: "Y",
      },
      party_name: {
        value: "",
        error: false,
        required: "Y",
      },
      party_desription: {
        value: "",
        error: false,
        required: "N",
      },
      party_rating: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShow(false);
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    const params = {
      party_code: formValues.party_code.value,
      party_name: formValues.party_name.value,
      party_desription: formValues.party_desription.value,
      party_rating: formValues.party_rating.value,
      clientrelated: clientRelated,
      carrier: carier,
    };
    try {
      const response = await dispatch(addParty(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/master/party-master/edit/${response.payload.data.data.party_id}`
          );
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const clientOptions = dataClientRelated.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const carierOptions = dataCarier.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleTypeClient = (code) => {
    setClientRelated([...clientRelated, { clientrelated_code: code }]);
  };

  const handleTypeClientRemove = (code) => {
    const data = clientRelated.filter(function(obj) {
      return obj.clientrelated_code !== code;
    });

    setClientRelated(data);
  };

  const handleCarier = (code) => {
    setCarier([...carier, { carrier_code: code }]);
  };

  const handleCarierRemove = (code) => {
    const data = carier.filter(function(obj) {
      return obj.carrier_code !== code;
    });

    setCarier(data);
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          New Party
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ThemeProvider theme={formLabelsTheme}>
          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                inputProps={{ maxLength: 128 }}
                required
                label="Code"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="party_code"
                value={formValues.party_code.value}
                onChange={handleChange}
                error={formValues.party_code.error}
                helperText={
                  formValues.party_code.error ? (
                    <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                      {iconError} {"This field is required"}
                    </FormHelperText>
                  ) : (
                    ""
                  )
                }
              />
              <RedditTextField
                required
                label="Name"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="party_name"
                value={formValues.party_name.value}
                onChange={handleChange}
                error={formValues.party_name.error}
                helperText={
                  formValues.party_name.error ? (
                    <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                      {iconError} {"This field is required"}
                    </FormHelperText>
                  ) : (
                    ""
                  )
                }
              />
            </Col>
            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                label="Rating"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="party_rating"
                onChange={handleChange}
                value={formValues.party_rating.value}
              />

              <RedditTextField
                label="Description"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="party_desription"
                onChange={handleChange}
                value={formValues.party_desription.value}
              />
            </Col>
          </Row>
          <div>
            <p className="font-weight-boldest mt-5">Party Type Settings</p>
            <hr />
            <div className="ml-5">
              <div>
                <p className="font-weight-boldest">Client Related</p>
                <Col xs={12} sm={3} md={8} lg={8}>
                  <Row>
                    {dataClientRelated.map((item, index) => {
                      return (
                        <Col md={3}>
                          <Form.Check
                            label={item.param_value}
                            value={item.param_code}
                            name="group1"
                            type="checkbox"
                            className="mr-8 mb-4"
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                handleTypeClient(item.param_code);
                              } else {
                                handleTypeClientRemove(item.param_code);
                              }
                            }}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </div>
              <div>
                <p className="font-weight-boldest">Carrier</p>
                <Col xs={12} sm={3} md={8} lg={8}>
                  <Row>
                    {dataCarier.map((item, index) => {
                      return (
                        <Col md={4}>
                          <Form.Check
                            label={item.param_value}
                            value={item.param_code}
                            name="group1"
                            type="checkbox"
                            className="mr-8 mb-4"
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                handleCarier(item.param_code);
                              } else {
                                handleCarierRemove(item.param_code);
                              }
                            }}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
